// ViewFeedModal.tsx

import React, {useState, useEffect} from "react";
import { Modal, Text, TextInput } from "@mantine/core";
import { IconPhoto, IconVideo } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataMain } from "./types";
import useAxiosPrivate from "../../auth/useAxiosPrivate";

interface ViewFeedModalProps {
  isOpen: boolean;
  onClose: () => void;
  feedData: RowDataMain;
}

const ViewFeedModal: React.FC<ViewFeedModalProps> = ({
  isOpen,
  onClose,
  feedData,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const [catList, setCatList] = useState<string[]>([]);

  const fetchCategory = async () => {
    try {
      const response = await axiosPrivate.get("/api/feed/read-category"); 
      const resDataArr = response.data.data;
      setCatList(["", resDataArr[0].name, resDataArr[1].name, resDataArr[2].name])
    } catch (err) {
      console.error("Failed to fetch contact [ERROR]:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchCategory()
  },[axiosPrivate]);
  
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>View</div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput label="Title" mb="sm" value={feedData.title} disabled />

      <TextInput label="Category" mb="sm" value={catList[Number(feedData.category)]} disabled />

      <Text className={classes.Text}>
        Video <span className={classes.format}>(.mp4)</span>
      </Text>
      <div className={classes.videoContainer}>
        {feedData.video ? (
          <video controls className={classes.videoSize}>
            <source src={feedData.video} type="video/mp4" />
            The content can't support
          </video>
        ) : (
          <p>
            <IconVideo />
          </p>
        )}
      </div>

      <Text className={classes.Text}>
        Thumbnail <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <div className={classes.thumbnailContainer}>
        {feedData.thumbnail ? (
          <img
            src={feedData.thumbnail}
            alt="Thumbnail"
            className={classes.thumbnailSize}
          />
        ) : (
          <p>
            <IconPhoto />
          </p>
        )}
      </div>

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewFeedModal;
